import Counterparty from "./Counterparty";
import RussianPassport from "./RussianPassport";
import Address from "./Address";
import CounterpartyVatHistory from "./CounterpartyVatHistory";

export default class CounterpartyNaturalPerson extends Counterparty {
  constructor(
    idInDB,
    externalId,
    itn,
    comment,
    counterpartyVatHistoryList,
    isIntragroupTurnover,
    firstName,
    lastName,
    patronymic,
    rrc,
    russianPassport,
    addresses
  ) {
    super(
      idInDB,
      externalId,
      "Natural person",
      itn,
      comment,
      counterpartyVatHistoryList,
      isIntragroupTurnover
    );

    this.firstName = firstName;
    this.lastName = lastName;
    this.patronymic = patronymic;

    this.rrc = rrc;
    this.russianPassport = russianPassport;
    this.addresses = addresses;

    this.displayName = this.getDisplayNameForList();
  }

  static createFromData(data) {
    let russianPassport;
    let addresses;
    let counterpartyVatHistoryList;

    // Паспорт
    if (data.russianPassport == null) {
      russianPassport = RussianPassport.createNew();
    } else {
      russianPassport = RussianPassport.createFromData(data.russianPassport);
    }

    if (data.addresses.length === 0) {
      addresses = [];
    } else {
      addresses = Address.createFromData(data.addresses);
    }

    // История НДС
    if (!data.counterpartyVatHistoryList || data.counterpartyVatHistoryList.length === 0) {
      counterpartyVatHistoryList = [];
    } else {
      counterpartyVatHistoryList = data.counterpartyVatHistoryList.map(
        x => CounterpartyVatHistory.createFromData(x)
      );
    }

    return new CounterpartyNaturalPerson(
      data.counterparty.idInDB,
      data.counterparty.externalId,
      data.counterparty.itn,
      data.counterparty.comment,
      counterpartyVatHistoryList,
      data.counterparty.isIntragroupTurnover,
      data.counterparty.firstName,
      data.counterparty.lastName,
      data.counterparty.patronymic,
      data.counterparty.rrc,
      russianPassport,
      addresses
    );
  }

  static createNew() {
    const russianPassport = RussianPassport.createNew();

    return new CounterpartyNaturalPerson(
      null,
      null,
      null,
      null,
      [],
      false,
      null,
      null,
      null,
      null,
      russianPassport,
      []
    );
  }

  static convertToSendData(item) {
    let addresses = [];
    for (let i = 0; i <item.addresses.length; i++) {
      let address = item.addresses[i];
      addresses.push(new Address(address.addressType, address.address, address.idInDB));
    }
    return {
      counterparty: {
        externalId: item.externalId,
        counterpartyType: item.counterpartyType,
        firstName: item.firstName,
        lastName: item.lastName,
        patronymic: item.patronymic,
        itn: item.itn,
        comment: item.comment,
        isIntragroupTurnover: item.isIntragroupTurnover
      },
      counterpartyVatHistoryList: item.counterpartyVatHistoryList.map(v =>
        CounterpartyVatHistory.convertToSendData(v)
      ),
      russianPassport: {
        counterpartyId: item.russianPassport.counterpartyId,
        dayDateDateOfIssue: item.russianPassport.dayDateDateOfIssue,
        monthDateDateOfIssue: item.russianPassport.monthDateDateOfIssue,
        yearDateDateOfIssue: item.russianPassport.yearDateDateOfIssue,
        issuer: item.russianPassport.issuer,
        divisionCode: item.russianPassport.divisionCode,
        passportSerialNumber: item.russianPassport.passportSerialNumber,
        passportNumber: item.russianPassport.passportNumber
      },
      addresses: addresses
    };
  }


  getDisplayName() {
    if (this.patronymic == null) return this.lastName + " " + this.firstName;
    else return this.lastName + " " + this.firstName + " " + this.patronymic;
  }

  getDisplayNameForList() {
    if (this.patronymic == null) return this.lastName + " " + this.firstName;
    else return this.lastName + " " + this.firstName + " " + this.patronymic;
  }

  getRussianPassportDate() {
    if (this.russianPassport.dayDateDateOfIssue !== null && this.russianPassport.monthDateDateOfIssue !== null) {
      let day = this.russianPassport.dayDateDateOfIssue;
      let month = this.russianPassport.monthDateDateOfIssue;
      if (day.toString().length == '1') {
        day = '0' + day;
      }

      if (month.toString().length == '1') {
        month = '0' + month;
      }

      return `${day}.${month}.${this.russianPassport.yearDateDateOfIssue}`;
    }
  }
}
